import {
  forwardRef,
  type InputHTMLAttributes,
  type SelectHTMLAttributes,
  type TextareaHTMLAttributes,
} from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, id, className = '', ...props }, ref) => {
    const inputId = id || props.name

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="sp-label">
            {label}
          </label>
        )}
        <input ref={ref} id={inputId} className={`sp-input ${className}`} {...props} />
        {error && (
          <p className="mt-1.5 text-sm" style={{ color: 'var(--sp-green)' }} role="alert">
            {error}
          </p>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, id, className = '', ...props }, ref) => {
    const inputId = id || props.name

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="sp-label">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={inputId}
          className={`sp-input resize-y ${className}`}
          {...props}
        />
        {error && (
          <p className="mt-1.5 text-sm" role="alert" style={{ color: 'var(--sp-green)' }}>
            {error}
          </p>
        )}
      </div>
    )
  }
)

Textarea.displayName = 'Textarea'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  error?: string
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, id, className = '', children, ...props }, ref) => {
    const inputId = id || props.name

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="sp-label">
            {label}
          </label>
        )}
        <select ref={ref} id={inputId} className={`sp-input ${className}`} {...props}>
          {children}
        </select>
        {error && (
          <p className="mt-1.5 text-sm" role="alert" style={{ color: 'var(--sp-green)' }}>
            {error}
          </p>
        )}
      </div>
    )
  }
)

Select.displayName = 'Select'
